export const DURATION = 'Varighed';
export const DISPLAY_IN_COURSE_LIBRARY = 'Vis på Spil I Undervisningen';
export const DISPLAY_IN_MU = 'Vis i MinUddannelse';
export const NEW_CHAPTER = 'Nyt kapitel';
